import React from 'react'

import {ToastProps} from '../models/ToastProps'
import ToastPropsStyle from "../../../models/ToastProps";
import ToastMsg from "../../../ToastMsg";
import colorUtils from "../../../../../colorUtils";

const styleError: ToastPropsStyle = {
    style: {color: colorUtils.theme.red100, bgColor: colorUtils.theme.white},
    icon: {color: 'white', ico: 'error'},
}

const ToastError = ({
                        className,
                        title,
                        body,
                        closeAction,
                        ...rest
                    }: ToastProps) => {
    return (
        <ToastMsg
            className="shared-toastError"
            toastStyle={styleError}
            title={title}
            body={body}
            closeAction={() => closeAction && closeAction()}
        ></ToastMsg>
    )
}

export default ToastError
